export default __webpack_public_path__ + "static/media/img7.6c15fee2.png";